import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

export function LoginPage() {
    const { instance, inProgress } = useMsal();

    const handleLogin = async () => {
        try {
            await instance.loginRedirect(loginRequest);
        } catch (error) {
            console.error("Login failed:", error);
        }
    };

    const isLoading = inProgress !== "none";

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#020873]">
            {/* Background decoration */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute -top-40 -right-40 w-80 h-80 bg-[#16ff2d] opacity-10 rounded-full blur-3xl"></div>
                <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-[#16ff2d] opacity-10 rounded-full blur-3xl"></div>
            </div>

            <div className="max-w-md w-full mx-4 relative z-10">
                <div className="bg-[rgba(255,255,255,0.05)] backdrop-blur-sm border border-[rgba(255,255,255,0.1)] rounded-2xl shadow-2xl p-8 space-y-8">
                    {/* Logo / Header */}
                    <div className="text-center">
                        <div className="flex justify-center mb-6">
                            <img
                                src="/logo-clippit.png"
                                alt="Clippit"
                                className="h-20 w-auto logo-wiggle"
                            />
                        </div>
                        <h1 className="text-3xl font-bold text-white">CRA</h1>
                        <p className="text-[rgba(255,255,255,0.6)] mt-2">
                            Gestion des Comptes Rendus d'Activité
                        </p>
                    </div>

                    {/* Login Button */}
                    <button
                        onClick={handleLogin}
                        disabled={isLoading}
                        className="w-full flex items-center justify-center gap-3 py-4 px-4 bg-[#16ff2d] hover:bg-[#12dd27] text-[#020873] font-semibold rounded-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-[#16ff2d]/20"
                    >
                        {isLoading ? (
                            <>
                                <svg
                                    className="animate-spin h-5 w-5 text-[#020873]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    />
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    />
                                </svg>
                                <span>Connexion en cours...</span>
                            </>
                        ) : (
                            <>
                                {/* Microsoft Logo */}
                                <svg className="w-5 h-5" viewBox="0 0 21 21" fill="none">
                                    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                                    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                                    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                                    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
                                </svg>
                                <span>Se connecter avec Microsoft</span>
                            </>
                        )}
                    </button>

                    {/* Footer */}
                    <p className="text-center text-xs text-[rgba(255,255,255,0.4)]">
                        Authentification sécurisée via Microsoft Entra ID
                    </p>
                </div>

                {/* Clippit branding */}
                <p className="text-center text-sm text-[rgba(255,255,255,0.4)] mt-6">
                    Powered by <span className="text-[#16ff2d] font-semibold">Clippit</span>
                </p>
            </div>
        </div>
    );
}

export default LoginPage;
